import { render, staticRenderFns } from "./SafetyAndHealth.vue?vue&type=template&id=29024232&scoped=true&"
import script from "./SafetyAndHealth.vue?vue&type=script&lang=js&"
export * from "./SafetyAndHealth.vue?vue&type=script&lang=js&"
import style0 from "./SafetyAndHealth.vue?vue&type=style&index=0&id=29024232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29024232",
  null
  
)

export default component.exports